import React from 'react'
import {BsLinkedin,BsGithub,BsTwitter} from 'react-icons/bs'

function HeaderSocials() {
  return (
    <div className='header_socials'>
        <a href="/" target='_blank'><BsLinkedin/></a>
        <a href="/" target='_blank'><BsGithub/></a>
        <a href="/" target='_blank'><BsTwitter/></a>
    </div>
  )
}

export default HeaderSocials